import { Theme, createStyles, makeStyles } from '../../../UI'

export default makeStyles((theme: Theme) =>
  createStyles({
    form: {
      width: '100%',
      marginTop: theme.spacing(1)
    },
    title: {
      textAlign: 'center',
      color: theme.palette.primary.dark
    },
    grid: {
      alignItems: 'center'
    },
    submit: {
      margin: theme.spacing(3, 0, 2.5)
    },
    email: {
      paddingBottom: theme.spacing(1)
    },
    emailLogin: {
      marginBottom: theme.spacing(1)
    },
    linkIcon: {
      width: '14px',
      height: '14px'
    },
    linkDesc: {
      fontWeight: 400,
      fontSize: '14px !important',
      lineHeight: '20.02px',
      color: '#72748D',
      gap: '8px !important',
      marginBottom: '20px'
    }
  })
)
